// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux
import { treatErrorAs } from 'api/errors';
import { errorLevel } from 'constants/errors';


import { sendSetPreferredDevice } from 'devices/senders';

import { getActiveUserId, getActiveOperationUuid } from 'current/selectors';
import { getDeviceByName } from 'devices/selectors';

// Action Types
export const typePrefix = 'vra/devices/';
export const actions = [
  'SET_ALL_DEVICES',
  'SET_PREFERRED_DEVICE',
  'SET_SELECTED_DEVICE',
  'SET_DRIVE_DEVICES',
  'SET_CHOOSE_FORMAT'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer (
  state = {},
  action = {}
) {
  switch (action.type) {

    case actions.SET_ALL_DEVICES:
      return {
        ...state,
        ...action.payload
      };

    case actions.SET_PREFERRED_DEVICE:
      return {
        ...state,
        preferred: action.payload
      };

    case actions.SET_SELECTED_DEVICE: 
      return {
        ...state,
        selected: action.payload
      };
    case actions.SET_CHOOSE_FORMAT:
      return{
        ...state,
        format: action.payload
      };
    case actions.SET_DRIVE_DEVICES:
      return {
        ...state,
        drive: action.payload
      };
    default:
      return state;
  }
}

// Action Creators

export const setAllDevices = ( devices ) => {
  return {
    type: actions.SET_ALL_DEVICES,
    payload: devices
  };
};

export const setPreferredDevice = (preferredDeviceName) => {
  return (dispatch, getState) => {
    const state = getState();
    const preferredDevice = getDeviceByName(state, preferredDeviceName);
    dispatch({
      type: actions.SET_PREFERRED_DEVICE,
      payload: preferredDevice
    });
  };
};

export const savePreferredDevice = (preferredDevice) => {
  return (dispatch, getState) => {
    const state = getState();
    const userId = getActiveUserId(state);
    let operationUuid = getActiveOperationUuid(state);
    const { label: preferredDeviceName } = preferredDevice;

    // update
    dispatch(setPreferredDevice(preferredDeviceName));
    return sendSetPreferredDevice({ operationUuid, preferredDeviceName: preferredDeviceName, userId })
    .catch( treatErrorAs({ severity: errorLevel.INFO, message: 'preferred device not updated' }) );
  };
};

export const saveSelectedDevice = (selectedDevice) => {
  return (dispatch) => {
    dispatch({
      type: actions.SET_SELECTED_DEVICE,
      payload: selectedDevice
    });
  };
};

export const setDriveDevices = driveDevices => {
  return {
    type: actions.SET_DRIVE_DEVICES,
    payload: driveDevices
  };
};

export const saveFormat = (selectedFormat) => {
  return (dispatch) => {
    dispatch({
      type: actions.SET_CHOOSE_FORMAT,
      payload: selectedFormat
    });
  };
};
